import React, { Component } from "react";
import RugAPI from "../../../api/rug";

export default class RugColors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: []
    };
  }

  loadColors = () => {
    const api = new RugAPI();
    api.getRugColors().then(response => {
      if (response.success) {
        this.setState({ colors: response.data });
      }
    });
  };

  componentDidMount() {
    this.loadColors();
  }

  render() {
    return (
      <div className="color-filter-body">
        {/* active for select */}
        {this.state.colors.map((color, i) => (
          <button
            key={color + i}
            className={this.props.selectedColors.indexOf(color.id) >= 0 ? "active" : ""}
            style={{ backgroundColor: color.hex_code }}
            onClick={() => this.props.changeHandler("colors", color.id)}
          ></button>
        ))}
      </div>
    );
  }
}
